export default __webpack_public_path__ + "static/media/powerladder_policy.f02e37ae.png";